// Order is FIXED — index matches position in sprite atlas (5×5 grid).
// atlas[i] → sx = (i % 5) * tileW, sy = Math.floor(i / 5) * tileW
export const TILES: ReadonlyArray<{ emoji: string; bg: string }> = [
  { emoji: '🫐', bg: '#5870D0' }, // 0  Blueberry     atlas [0,0]
  { emoji: '👑', bg: '#FFD020' }, // 1  Crown          atlas [0,1]
  { emoji: '🤍', bg: '#E8E4DC' }, // 2  Cotton         atlas [0,2]
  { emoji: '💎', bg: '#B078E0' }, // 3  Crystal        atlas [0,3]
  { emoji: '🫛', bg: '#70C050' }, // 4  Pea Pod        atlas [0,4]
  { emoji: '🌸', bg: '#F07090' }, // 5  Pink Flower    atlas [1,0]
  { emoji: '🌷', bg: '#E04060' }, // 6  Tulip          atlas [1,1]
  { emoji: '🌈', bg: '#80C8F0' }, // 7  Rainbow        atlas [1,2]
  { emoji: '🍋', bg: '#F0D840' }, // 8  Lemon          atlas [1,3]
  { emoji: '🍄', bg: '#D84020' }, // 9  Mushroom       atlas [1,4]
  { emoji: '🌻', bg: '#FFD020' }, // 10 Sunflower      atlas [2,0]
  { emoji: '🍐', bg: '#C8C840' }, // 11 Pear           atlas [2,1]
  { emoji: '🍂', bg: '#E06020' }, // 12 Maple Leaf     atlas [2,2]
  { emoji: '💧', bg: '#60B0E0' }, // 13 Water Drop     atlas [2,3]
  { emoji: '🍓', bg: '#E02040' }, // 14 Strawberry     atlas [2,4]
  { emoji: '🐚', bg: '#D8C8A8' }, // 15 Shell          atlas [3,0]
  { emoji: '🦋', bg: '#8060C8' }, // 16 Butterfly      atlas [3,1]
  { emoji: '🍏', bg: '#70B840' }, // 17 Green Apple    atlas [3,2]
  { emoji: '💜', bg: '#9070B8' }, // 18 Lavender       atlas [3,3]
  { emoji: '💗', bg: '#FF4080' }, // 19 Heart          atlas [3,4]
  { emoji: '❄️', bg: '#80C0F0' }, // 20 Snowflake      atlas [4,0]
  { emoji: '🍑', bg: '#F09060' }, // 21 Peach          atlas [4,1]
  { emoji: '🥦', bg: '#70A878' }, // 22 Kohlrabi       atlas [4,2]
  { emoji: '⭐', bg: '#F07030' }, // 23 Starfish       atlas [4,3]
  { emoji: '🐞', bg: '#D82020' }, // 24 Ladybug        atlas [4,4]
];
